import i18n from "../../shared/i18n";

class Utils {
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   * Deep diff between two object, using lodash
   * @param  {Object} object Object compared
   * @param  {Object} base   Object to compare with
   * @return {Object}        Return a new object who represent the diff
   */
  static difference(object, base) {
    function changes(object, base) {
      return _.transform(object, function (result, value, key) {
        value = value === '' ? null : value;
        base[key] = base[key] === '' ? null : base[key];

        if (value !== null && typeof value !== 'object') {
          value = value + '';
        }

        if (base[key] !== null && typeof base[key] !== 'object') {
          base[key] = base[key] + '';
        }

        if (!_.isEqual(value, base[key])) {
          result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
        }
      });
    }

    return changes(object, base);
  }

  static isDifferent(object, base) {
    let result = this.difference(object, base);
    return Object.keys(result).length > 0;
  }

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   * @param failedFilesData
   * @param vm
   */
  static parseFailedImagesData(failedFilesData, vm) {
    const errors = [];
    for (let data of failedFilesData) {
      if (data.failure_reason === 'type') {
        errors.push(i18n.t('{filename} - invalid file extension', {filename: data.file.name}));
      } else if (data.failure_reason === 'size') {
        errors.push(i18n.t(`{filename} - max file size exceeded`, {filename: data.file.name}) + (data.maxSize ? ` (${data.maxSize}MB)`: ''));
      }
    }
    Utils.showErrorsInDialog(errors, vm);
  }

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   * @param errors
   * @param vm
   * @param title
   */
  static showErrorsInDialog(errors, vm, title = null) {
    const listItemsArr = [];
    for (let error of errors) {
      listItemsArr.push(vm.$createElement('li', {}, error));
    }
    vm.$errorDialog(
      vm.$createElement('ul', {class: "mb-0"}, listItemsArr),
      title || i18n.t('Image Validation Error')
    );
  }
}

export {
  Utils
};
